import React from 'react';
import {BrowserRouter as Router, Route} from "react-router-dom";
import AuthWrap from './pages/Auth/containers/AuthWrap';
import Header from './components/Header';
import ContentWrapper from './components/ContentWrapper';
import SignUp from './components/signUp';
//import NewLayout from './NewLayout'

function App() {
  return (
    <div>
      <Router>
        <Header />
        <ContentWrapper>
          <Route path="/" exact component={AuthWrap} />
          <Route path="/verifyEmail" component={AuthWrap} />
          <Route path="/setPassword" component={AuthWrap} />
          <Route path="/forgotPassword" component={AuthWrap} />
          <Route path="/signUp" component={SignUp} />
        </ContentWrapper>
      </Router>
    </div>
  );
}

export default App;
